import React from 'react'
import { Link } from 'react-router-dom';

function Notfound() {
  return (
    <div className="container text-center my-5">
         <img className="img-fluid w-50" src={process.env.PUBLIC_URL + "/no-file.png"} alt="No Movies" /><br/>
         <Link to="/" type="button" className="btn btn-warning text-center text-white w-25">Go Home</Link>
         
    </div>
  )
}

export default Notfound;